<template>
  <v-container>
    <v-card style="padding: 10px">
      <v-card-title>
        <div style="width: 100%">
          BO'LIMLAR
        </div>
        <form
            novalidate
            style="width: 100%; margin-top: 30px"
            @submit.prevent="getPage()"
        >
          <v-row>
            <v-spacer/>
            <v-col md="4" sm="12">
              <v-text-field
                  v-model="criteria.name"
                  append-icon="mdi-magnify"
                  dense
                  label="NOMI"
                  outlined
                  @click:append="getPage()"
              />
            </v-col>
            <v-col md="12" sm="12">
              <v-spacer/>
              <v-btn color="primary" to="/category-edit">Yangi qo'shish</v-btn>
            </v-col>
          </v-row>
        </form>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" hide-default-footer>
        <template v-slot:item.action="{ item }">
          <v-btn-toggle>
            <v-btn
                color="info"
                small
                @click="$router.push(`/category-edit/${item.id}`)"
            >
              <v-icon color="white" small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn color="red" small @click="deleteItem(item)">
              <v-icon color="white" small>mdi-delete</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-pagination
            v-model="currentPage"
            :length="pageable.totalPages"
            :total-visible="7"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
        ></v-pagination>
      </v-card-actions>
    </v-card>
    <v-snackbar :value="snackbar" color="success" outlined right>
      Bo'lim ochrildi!
    </v-snackbar>
  </v-container>
  </template>
<script>
import service from "./category.service";

export default {
  data: () => ({
    currentPage: 1,
    snackbar: false,
    dialog: false,
    headers: [
      {
        text: "Id",
        value: "id",
        divider: "true",
        align: "end",
        width: "10%",
      },
      {
        text: "NOMI",
        value: "name",
        divider: "true",
        align: "start",
        width: "50%",
      },
      {
        text: "KITOBLAR SONI",
        value: "amountBooks",
        divider: "true",
        align: "center",
        width: "20%",
      },
      {
        text: "",
        value: "action",
        align: "center",
        width: "20%",
      },
    ],
    categorys: [],
    criteria: {
      name: "",
    },
    pageable: {
      page: 0,
      size: 10,
      sort: "desc",
      sortBy: "id",
      totalPages: 1,
    },
  }),
  methods: {
    getPage() {
      service.getAll(this.pageable, this.criteria).then((res) => {
        this.pageable.totalPages = res.data.totalPages
        this.categorys = res.data.content;
      });
    },
    initial() {
      this.getPage();
    },
    deleteItem(item) {
      confirm("Ma'lumotlarni ochirishni tasdiqlaysizmi?") &&
      service
          .delete(item)
          .then(() => {
            this.getPage();
            this.snackbar = true;
          })
          .catch((err) => {
            alert(err);
          });
    },
  },
  created() {
    this.initial();
  },
  computed: {
    items() {
      return this.categorys
    }
  },
  watch: {
    currentPage(newVal) {
      if (newVal > 0) {
        this.pageable.page = newVal - 1;
        this.getPage();
      }
    },
  },
};
</script>
